<template>
    <div class="disclaimer-wrapper primary-bd-ee" ref='sign1'>
        <span class="content sub-text-99">{{propsData.disclaimer}}</span>
        <span class="reportingBtn sub-text-46" @click.stop="showReport">举报</span>
        <div class="reportingTab sub-bg-ff sub-box-shadow" v-show="model.showFlag" v-clickoutside="handleClose" @click.stop="model.showFlag=!model.showFlag">
            <div :key="index" v-for="(item,index) in arr" class="primary-text-26 sub-bd-ee" @click="subimfor(item.id)">{{item.tag}}</div>
            <div @click="cancel" class="primary-text-26">取消</div>
        </div>
    </div>
</template>

<script>
import * as actions from '@/common/js/api.js'

export default {
    name: '',
    data() {
        return {
            model: {
                showFlag: false,
                disclaimer: "本文转载上述内容出于传递更多信息之目的，不代表同花顺财经观点。同花顺力求但不保证数据的完全准确，如有错漏请以证监会指定上市公司信息披露平台为准，各类信息服务基于人工智能算法，投资者据此操作，风险自担。",
                seq: 654,
            },
            arr: [
                { tag: "广告软文", id: 0 },
                { tag: "低俗谣言", id: 1 },
                { tag: "敏感时政", id: 2 },
                { tag: "标题夸张", id: 3 },
                { tag: "内容有误", id: 4 },
                { tag: "错别字", id: 5 }
            ],
            // showReport: getAccount(),
            stats: this.$pageStat(this.propsData.seq, 'disclaimer')
        }
    },
    props: {
        propsData: {
            type: Object,
            default() {
                return {
                    disclaimer: '以上资讯由同花顺AI写手完成，写作系统尚处于测试阶段，内容仅供参考，同花顺力求但不保证数据的完全准确，如有错漏请以证监会指定上市公司信息披露平台为准。',
                    seq: '615868644'
                }
            }
        }
    },
    watch: {
        // propsData: {
        //     handler() {
        //         setTimeout((_ => {
        //             this.$utils.judgeScrollDistance(this.$refs.sign1, () => { this.$sendStat(this.stats('disclaimerreveal')) })
        //         }), 3000);
        //     },
        //     immediate: true,
        //     deep: true,
        // }
    },
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {

    },
    mounted: function () {
    },

    methods: {
        handleClose(e) {
            this.model.showFlag = false;
        },
        cancel() {
            // this.$sendPoint(`jb_qx`)
            this.$sendStat(`pc_newschrome_${window.statSeq}.report.cancel.click`);
        },
        showReport() {
            this.model.showFlag = !this.model.showFlag
            // this.$sendPoint(`jb_click`)
            this.$sendStat(`pc_newschrome_${window.statSeq}.report.click`);
        },
        subimfor(db) {
            // this.$sendPoint(`jb_${db}`)
            this.$sendStat(`pc_newschrome_${window.statSeq}.report.${++db}.click`);

            let userid = getAccount()
            if (!userid) {
                this.$client.showBrowserDlgTip({ text: "您还未登录，请先登录" });
                return;
            }
            let timeStamp = (new Date()).valueOf();
            let tipname = this.arr[db].tag
            let tipseq = this.model.seq;
            this.$http.getReport.call(this, tipname, tipseq, userid, timeStamp).then(res => {
                if (res.code == 200) {
                    // this.$sendStat(this.stats('disclaimerrepport'))
                    // this.$sendPoint(`jb_cg`)
                    this.$sendStat(`pc_newschrome_${window.statSeq}.report.toast`);

                    //成功的话，调toast->弹窗，举报成功 
                    this.$client.showBrowserDlgTip({ text: "举报成功" })
                }
            })
        }

    }

}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';

.disclaimer-wrapper {
    font-size: 12px;
    line-height: 24px;
    padding-top: 8px;
    border-top-width: 1px;
    border-top-style: solid;
    position: relative;
    // padding-bottom: 5px;
    > span {
        &.reportingBtn {
            float: right;
            cursor: pointer;
        }
    }
    .reportingTab {
        width: 100px;
        height: 244px;
        z-index: 100000;
        position: absolute;
        right: 0;
        bottom: 20px;
        border-radius: 2px;
        text-indent: 10px;
        > div {
            width: 100%;
            height: 34px;
            font-size: 12px;
            line-height: 34px;
            border-bottom-width: 1px;
            border-bottom-style: solid;
            cursor: pointer;
            &:last-child {
                border-bottom: none;
            }
        }
    }
}
</style>
